__turbopack_context__.v({
  "button": "mcUs5a_button",
  "button-loading-pulse": "mcUs5a_button-loading-pulse",
  "error": "mcUs5a_error",
  "icon": "mcUs5a_icon",
  "iconOnly": "mcUs5a_iconOnly",
  "info": "mcUs5a_info",
  "lg": "mcUs5a_lg",
  "loading": "mcUs5a_loading",
  "md": "mcUs5a_md",
  "onBrand": "mcUs5a_onBrand",
  "onDark": "mcUs5a_onDark",
  "primary": "mcUs5a_primary",
  "rounded": "mcUs5a_rounded",
  "secondary": "mcUs5a_secondary",
  "sm": "mcUs5a_sm",
  "splitMain": "mcUs5a_splitMain",
  "splitSecondaryMain": "mcUs5a_splitSecondaryMain",
  "splitToggle": "mcUs5a_splitToggle",
  "success": "mcUs5a_success",
  "tertiary": "mcUs5a_tertiary",
  "text": "mcUs5a_text",
  "warning": "mcUs5a_warning",
});
